import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.bold";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import GBColorPropType from '../../prop-types/GBColor';
import styles from './text.css';
import colorStyles from '../../styles/colors.css';
import SizePropType from '../../prop-types/Size';
var cx = classnames.bind(styles);
var COLOR_CLASSES = {
  teal: colorStyles.textTeal,
  red: colorStyles.textRed,
  green: colorStyles.textGreen,
  evergreen: colorStyles.textEvergreen,
  white: colorStyles.textWhite,
  gold: colorStyles.textGold,
  grey: colorStyles.textGrey,
  orange: colorStyles.textOrange
};
export default function Text(_ref) {
  var Element = _ref.as,
      className = _ref.className,
      bold = _ref.bold,
      italic = _ref.italic,
      centered = _ref.centered,
      right = _ref.right,
      floated = _ref.floated,
      color = _ref.color,
      size = _ref.size,
      uppercase = _ref.uppercase,
      elongated = _ref.elongated,
      fluidProp = _ref.fluid,
      screenReader = _ref.screenReader,
      rest = _objectWithoutProperties(_ref, ["as", "className", "bold", "italic", "centered", "right", "floated", "color", "size", "uppercase", "elongated", "fluid", "screenReader"]);

  var colorClass = COLOR_CLASSES[color];
  var fluid = fluidProp || centered || !floated && right;
  return React.createElement(Element, _extends({
    className: cx(colorClass, size, {
      bold: bold,
      italic: italic,
      right: right,
      fluid: fluid,
      centered: centered,
      left: !right && !centered,
      floated: floated,
      uppercase: uppercase,
      elongated: elongated,
      screenReader: screenReader
    }, className)
  }, rest));
}
Text.propTypes = {
  /** String or component to replace the tag name */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /** Class name to apply to component */
  className: PropTypes.string,

  /** Boolean to indicate if the text should be bolded */
  bold: PropTypes.bool,

  /** Boolean to indicate if the text should be italicized */
  italic: PropTypes.bool,

  /** Boolean to indicate if the text should be centered */
  centered: PropTypes.bool,

  /** Boolean to indicate if the text should be right-aligned */
  right: PropTypes.bool,

  /** Boolean to indicate if the text should be floated */
  floated: PropTypes.bool,

  /** Text color */
  color: GBColorPropType,

  /** Boolean to indicate if the text should fill the parent width */
  fluid: PropTypes.bool,

  /** Text size */
  size: SizePropType,

  /** Boolean to indicate if the text should be uppercase */
  uppercase: PropTypes.bool,

  /** Boolean indicating if the letter spacing should increase */
  elongated: PropTypes.bool,

  /** Boolean indicating if the text should only display for screen readers */
  screenReader: PropTypes.bool
};
Text.defaultProps = {
  as: 'span',
  className: undefined,
  bold: false,
  italic: false,
  centered: false,
  right: false,
  floated: false,
  color: null,
  fluid: false,
  size: undefined,
  uppercase: false,
  elongated: false,
  screenReader: false
};